module.exports = __webpack_public_path__ + "static/media/profile.5a8edbb9.png";